import * as Ably from 'ably';
import { getAuthUserId } from '../lib/auth';

const ablyKey = process.env.REACT_APP_ABLY_KEY || '';

export const ablyClient = new Ably.Realtime({
    key: ablyKey,
    clientId: getAuthUserId(),
    autoConnect: true
});

export function getChannelName(channelName: string) {
    const env = process.env.REACT_APP_ENV || 'production';
    return `${env}:${channelName}:${getAuthUserId()}`;
}
